import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchUploadFile(data:any) {
  const response = await instance.post(`https://ethicsgov-dev.m-devsecops.com/api/admin/messages/uploadImage`, data.data, data.headers);
  return response.data;
}
